import {
  HISTORY_IDENTIFICATOR,
  MOBILE_SCREEN_WIDTH,
  SMALL_SCREEN_WIDTH
} from "./vars";

export const normalizeIDForUrl = id => {
  return replaceCharInStr(id, "_", "/");
};

export const normalizeUrlForID = url => {
  return replaceCharInStr(url, "/", "_");
};

export const getAnchorIDFromUrl = () => {
  if (HISTORY_IDENTIFICATOR === "#") return window.location.hash.substr(1);
  if (HISTORY_IDENTIFICATOR === "/")
    return normalizeUrlForID(window.location.pathname.slice(1));
};

export const replaceCharInStr = (string, remove, add) => {
  return string.split(remove).join(add);
};

export const addToBrowserHistory = url => {
  try {
    history.pushState(null, null, HISTORY_IDENTIFICATOR + url);
  } catch (e) {
    console.log("history not available");
  }
};

export const hasScrollBar = $element =>
  $element.get(0).scrollHeight > $element.outerHeight();

export const getPageFromInfoPopupID = id =>
  $(`[data-info-popup="#${normalizeIDForUrl(id)}"]`).first();

export const getPageFromVideoPopupID = id =>
  $(`.page-content:has(a[href="${id}"])`);

export const isMobileScreen = () => {
  if (isLandscape()) return window.innerHeight <= MOBILE_SCREEN_WIDTH;
  else return window.innerWidth <= MOBILE_SCREEN_WIDTH;
};

export const isSmallScreen = () => window.innerWidth <= SMALL_SCREEN_WIDTH;

export const isLandscape = () =>
  window.orientation === 90 || window.orientation === -90;

export const debounce = (func, wait, immediate) => {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const playPlyrElement = $video => {
  const player = $video.get(0).plyr;
  player.play();
};

export const isScrollable = (el) => {
  if (!el) return null;
  return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
}

export const isScrolledToBottom = (el, threshold = 1) => {
  if (!el) return false;
  return el.scrollHeight - el.scrollTop - el.clientHeight <= threshold;
}

export const isScrolledToTop = (el, threshold = 1) => {
  if (!el) return false;
  return el.scrollTop <= threshold;
}

export const userAgent = () => {
  const ua = navigator.userAgent;

  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
  
  const isFirefox = /Firefox\/\d+/i.test(ua) && !/Seamonkey/i.test(ua);
  const isChrome = /Chrome\/\d+/i.test(ua) && !/Edge|Edg|OPR|Brave/i.test(ua);
  const isSafari = /Safari/i.test(ua) && !/Chrome|Chromium|Edg|OPR|Brave/i.test(ua);

  isMobile && document.documentElement.classList.add('mobile');
  isFirefox && document.documentElement.classList.add('firefox');
  isChrome && document.documentElement.classList.add('chrome');
  isSafari && document.documentElement.classList.add('safari');
}